import { render } from "./VueWebCam.vue?vue&type=template&id=07602f93"
import script from "./VueWebCam.vue?vue&type=script&lang=js"
export * from "./VueWebCam.vue?vue&type=script&lang=js"

import "./VueWebCam.vue?vue&type=style&index=0&id=07602f93&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\payroll-system\\dashboards\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__